import { __assign, __rest } from "tslib";
/**
 * @see https://github.com/NervJS/taro/blob/next/packages/taro-components/virtual-list/index.d.ts
 */
import React, { useContext, useMemo } from "react";
import { FixedSizeList } from "react-window";
import { callBoth } from "../../../_util/call-both";
import { PageScroller } from "./pageScroller";
var ListContext = React.createContext({});
export default function VirtualList(_a) {
    var usePageScroll = _a.usePageScroll, 
    // renderTop,
    renderBottom = _a.renderBottom, props = __rest(_a, ["usePageScroll", "renderBottom"]);
    var outerElementType = useMemo(function () {
        return React.forwardRef(function (_a, ref) {
            var children = _a.children, props = __rest(_a, ["children"]);
            var _b = useContext(ListContext), top = _b.top, bottom = _b.bottom;
            return (React.createElement("div", __assign({ ref: ref }, props),
                top,
                children,
                bottom));
        });
    }, []);
    if (usePageScroll) {
        return (React.createElement(ListContext.Provider, { value: { bottom: renderBottom } },
            React.createElement(PageScroller, null, function (_a) {
                var ref = _a.ref, outerRef = _a.outerRef, style = _a.style, onScroll = _a.onScroll;
                return (React.createElement(FixedSizeList, __assign({}, props, { ref: ref, outerRef: outerRef, height: window.innerHeight, style: style, onScroll: callBoth(onScroll, props.onScroll), outerElementType: outerElementType })));
            })));
    }
    return (React.createElement(ListContext.Provider, { value: { bottom: renderBottom } },
        React.createElement(FixedSizeList, __assign({}, props, { outerElementType: outerElementType }))));
}
//# sourceMappingURL=VirtualList.js.map